<template>
<div class="chapter">
<div class="inner_page">
<p class="extract">Become conscious for a single moment that Life and intelligence are purely spiritual,—neither in nor of matter,—and the body will then utter no complaints.</p>
<p class="right">—Mary Baker Eddy, <em>Science and Health with Key to the Scriptures</em></p>
<p class="extract">I won’t be dying after all, not now, but will go on living dizzily hereafter in reality, half-deaf to reality, in the room perfumed by the fire that our inextinguishable will begins.</p>
<p class="right">—Timothy Donnelly, “The New Intelligence”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?1f370a3a